import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import ReactPlayer from 'react-player';
import bannerImage from '../assets/fondos/3.jpg';
import WhatsAppButton from '../components/WhatsAppButton';
import useFacebookPixel from "../hooks/useFacebookPixel";
import SocialButtons from "../components/SocialButton";
import "./recuadro.css";

const UnirseCliente = () => {
  const { usuario } = useParams();
  useFacebookPixel(usuario); 
  const { trackLead } = useFacebookPixel(usuario);
  const [data, setData] = useState(null);
  const playerRef = useRef(null);
  const navigate = useNavigate();

  const loginUserJSON = window.localStorage.getItem('loginUser');
  const loggedInUser = loginUserJSON ? JSON.parse(loginUserJSON) : null;
  const userWS = loggedInUser ? loggedInUser.tlfwhatsapp : null;

  const [userdata, setUserdata] = useState("");

  const fetchUserInfo = async () => {
    try {
      const response = await axios.get(
       `https://api.mrcirp.com/public/infocampanas/${usuario}`
      );
      setUserdata(response.data[0]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`https://api.mrcirp.com/public/usuariolanding/${usuario}`);
      setData(response.data[0]);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      await fetchUserInfo();
      await fetchData();
    };
    fetchAllData();
  }, [usuario]);

  const handleBack = () => {
    navigate(-1);
  };

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1>Bienvenido al equipo</h1>
        
        <div style={styles.videoContainer}>
          <ReactPlayer
            ref={playerRef}
            url={data.urlcomounirsecliente}
            width="100%"
            height="100%"
            controls={true}
            style={styles.video}
          />
        </div>

        <div style={styles.buttonContainer}>
          <a 
            href={data.urlBotonProducto} 
            style={styles.highlightButton} 
            onClick={trackLead} 
            target="_blank"
            rel="noreferrer"
          >
            UNIRTE AHORA
          </a>
          <button style={styles.button} onClick={handleBack}>
            VOLVER
          </button>
        </div>
      </div>
      
      <WhatsAppButton
         phoneNumber={userdata.whatsapp}
        message="Hola, me gustaría obtener más información."
      />
      <SocialButtons
        pdfUrl={userdata.pdf}
        facebookUrl={userdata.facebook}
        instagramUrl={userdata.instagram}
        linkedinUrl={userdata.linkedin}
        tiktokUrl={userdata.tiktok}
        calendlyUrl={userdata.calendly}
        onContactClick={(network) => console.log(`Se hizo clic en ${network}`)}
      />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${bannerImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '100vh',
    padding: '20px',
    color: '#fff',
  },
  content: {
    textAlign: 'center',
    maxWidth: '800px',
    width: '100%',
  },
  videoContainer: {
    width: '100%',
    maxWidth: '600px',
    margin: '0 auto 30px',
    aspectRatio: '16/9',
    position: 'relative',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    marginTop: '20px',
  },
  button: {
    padding: '12px 25px',
    fontSize: '16px',
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#000',
    border: 'none',
    borderRadius: '5px',
    transition: 'all 0.3s ease',
    width: '100%',
    maxWidth: '300px',
  },
  highlightButton: {
    padding: '15px 30px',
    fontSize: '18px',
    cursor: 'pointer',
    backgroundColor: '#00f60a',
    color: '#000',
    border: '2px solid #000',
    borderRadius: '5px',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    width: '100%',
    maxWidth: '300px',
    fontWeight: 'bold',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    animation: 'pulse 1.5s infinite',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    },
    '50%': {
      transform: 'scale(1.03)',
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
    },
    '100%': {
      transform: 'scale(1)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    },
  },
};

export default UnirseCliente;